import type { Components } from '@mui/material/styles';
import { type Theme } from '@mui/material/styles';

export const formLabelTheme: Pick<Components<Theme>, 'MuiFormLabel'> = {
  MuiFormLabel: {
    styleOverrides: {
      root: ({ theme }) => ({
        fontSize: theme.typography.body2.fontSize, // smaller font size -- mui defaults to 16px
      }),
    },
  },
};
